export default __webpack_public_path__ + "static/media/foret.cbf87699.jpg";